<template>
  <div class="floatingwindow-box">
    <div class="floatingwindow-ul">
      <div class="floatingwindow-li">
        <img src="@/assets/images/qd1.png"/>
        <div>立即签到</div>
      </div>
      <div class="floatingwindow-li">
        <img src="@/assets/images/qd2.png"/>
        <div>下载APP</div>
      </div>
      <div class="floatingwindow-li">
        <img src="@/assets/images/qd3.png"/>
        <div>返回顶部</div>
      </div>
    </div>
    <div class="floatingwindow-bottom">
      <img src="@/assets/images/qd4.png"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "index"
  }
</script>

<style lang="less" scoped>
  .floatingwindow-box{
    position: fixed;
    right: 32px;
    top: 35%;
    .floatingwindow-ul{
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      background: #fff;
      border-radius: 8px;
      width: 72px;
      padding: 0 12px;
      box-sizing: border-box;
      .floatingwindow-li:last-child{
        border-bottom: none;
      }
      .floatingwindow-li{
        padding: 18px 0;
        color: rgba(98, 99, 101, 1);
        font-size: 12px;
        border-bottom: 1px solid rgba(228, 228, 229, 1);
        line-height: 12px;
        cursor: pointer;
        img{
          width: 24px;
          display: block;
          margin: auto;
          margin-bottom: 8px;
        }
      }
    }
    .floatingwindow-bottom{
      border-radius: 8px;
      margin-top: 16px;
      overflow: hidden;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      img{
        width: 72px;
        display: block;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/floatingwindow.vue